import useToggle from '@alltrails/shared/hooks/useToggle';
import Modal from 'components/Modal';

export default function PlusUpsell() {
  const [isOpen, toggle] = useToggle(true);

  return (
    <Modal isOpen={isOpen} onRequestClose={toggle}>
      plus upsell experiment
    </Modal>
  );
}
